module.exports = __webpack_public_path__ + "static/media/antigua-accommodation.a0cd9771.jpg";